import { deleteRequest, get, post, postfd, put } from "../helpers/apihelpers";


export const UpdateNotificationService=async(data,id)=>{
    try {
        const result = await put(`api/notification/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetNotificationService=async(page,text,from_date,to_date,step)=>{
    try {
        const result = await get(`api/notification/get?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}&step=${step}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetUnreadNotificationService=async(page)=>{
    try {
        const result = await get(`api/notification/get_unread?page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateAllReadNotificationService=async(data)=>{
    try {
        const result = await put(`api/notification/update_all_read`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const MarkAllReadNotificationService=async(data)=>{
    try {
        const result = await put(`api/notification/mark_all_as_read`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

